import React from "react";
import withStyles from "isomorphic-style-loader/lib/withStyles";
import { withRouter } from "react-router-dom";
import s from "./styles.scss";
import { Button, Row, Col, Container, Label, Input } from "reactstrap";
import ModalFrame from "../../../toolkit/modalFrame";
import BaseInput from "../../../toolkit/baseInput";
import { getMonthsWithoutInterestsByBankId } from "../../actions/banks";
import { handleRequestError } from "../../../utils/helpers";

interface Props {
  isOpen: boolean;
  amount: number;
  enLinea: boolean;
  hasMembershipsOrTokenizationProducts: boolean;
  hasMaintenancesProducts: boolean;
  showTokenizationControl: boolean;
  generarLineaPago: (tokenizar: boolean, msi: number) => any;
  generarLineaPagoEnLinea: (msi: number) => any;
  cancelar: () => any;
}

interface State {
  check: boolean;
  msi: any;
  msiCatalog: any;
}

class LineaPagoModal extends React.Component<Props, State> {
  state = {
    check: false,
    msi: 0,
    msiCatalog: []
  };

  componentDidMount() {
    getMonthsWithoutInterestsByBankId(342)
      .then(({ data }) => {
        this.setState({ msiCatalog: [...data] });
      })
      .catch(handleRequestError);
  }

  componentWillUnmount() {
    this.setState({ check: false, msi: 0 });
  }

  getMsiCatalog() {
    const total = this.props.amount || 0;

    const _defOptions = [{ value: null, label: "Contado" }];

    let options = [];
    if (!this.props.hasMaintenancesProducts) {
      options = (this.state.msiCatalog || [])
        .filter(x => (x.monto || 0) <= total)
        .map(x => {
          return { value: x.meses, label: x.meses };
        });
    }

    return [..._defOptions, ...options];
  }

  render() {
    return (
      <Container className="p-0">
        <ModalFrame
          title={"Generar línea de pago"}
          isOpen={this.props.isOpen}
          size="md"
        >
          {!this.props.enLinea && (
            <div>
              Se creará una Línea de pago con todos los items seleccionados.
              ¿Desea continuar?
            </div>
          )}

          {!!this.props.enLinea && (
            <div>
              Se iniciará el pago en línea con todos los items seleccionados.
              ¿Desea continuar?
            </div>
          )}

          <br />

          {!!this.props.showTokenizationControl && (
            <div className="mt-3">
              <div>
                <Label className={s.label} for="horaInicial">
                  Tokenizar tarjeta para envío a CAT
                </Label>
              </div>
              <div className="pl-4 mt-2">
                <Label check>
                  <Input
                    type="checkbox"
                    checked={
                      this.props.hasMembershipsOrTokenizationProducts ||
                      this.state.check
                    }
                    onChange={e => {
                      this.setState({ check: e.target.checked });
                    }}
                    disabled={!!this.props.hasMembershipsOrTokenizationProducts}
                  />
                  Registrar medio de pago principal al pagar la línea de pago
                </Label>
              </div>
            </div>
          )}

          <div className="mt-3">
            <BaseInput
              type="select"
              label="Meses sin intereses"
              name="msiValue"
              id="msiValue"
              options={this.getMsiCatalog()}
              value={this.state.msi}
              onChange={e => {
                const value = e.target.value;
                this.setState({ msi: value });
              }}
            />
          </div>

          <div className="mt-3">
            <BaseInput
              label={"Monto"}
              name="lpAmoutn"
              id="lpAmoutn"
              type="text"
              placeholder="Monto"
              value={this.props.amount || 0}
              disabled={true}
            />
          </div>
          <hr />
          <Row className={`${s.customDistancia}`}>
            {!this.props.enLinea && (
              <Col>
                <Button
                  block
                  color="secondary"
                  onClick={() => {
                    if (this.props.generarLineaPago) {
                      const tokenizar =
                        !!this.props.hasMembershipsOrTokenizationProducts ||
                        !!this.state.check;
                      const msi = this.state.msi || 0;
                      this.props.generarLineaPago(tokenizar, msi);
                      this.setState({ check: false });
                    }
                  }}
                  disabled={
                    (this.props.amount || 0) <= 0 ||
                    (this.state.msiCatalog || []).length <= 0
                  }
                >
                  ENVIAR LÍNEA
                </Button>
              </Col>
            )}
            {!!this.props.enLinea && (
              <Col>
                <Button
                  block
                  color="secondary"
                  onClick={() => {
                    if (this.props.generarLineaPagoEnLinea) {
                      const msi = this.state.msi || 0;
                      this.props.generarLineaPagoEnLinea(msi);
                      this.setState({ check: false });
                    }
                  }}
                  disabled={
                    (this.props.amount || 0) <= 0 ||
                    (this.state.msiCatalog || []).length <= 0
                  }
                >
                  PAGO EN LÍNEA
                </Button>
              </Col>
            )}
            <Col>
              <Button
                block
                color="primary"
                onClick={() => {
                  if (this.props.cancelar) {
                    this.setState({ check: false, msi: 0 });
                    this.props.cancelar();
                  }
                }}
              >
                CANCELAR
              </Button>
            </Col>
          </Row>
        </ModalFrame>
      </Container>
    );
  }
}

export default withRouter(withStyles(s)(LineaPagoModal));
